import 'antd/dist/reset.css';

import React from "react";
import { createRoot } from "react-dom/client";

import { ConfigProvider } from "antd";

import { notification } from 'antd';

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

notification.config({
  placement: 'topRight',
  getContainer: () => document.getElementById('notification-root'),
  duration: 3,
});

const container = document.getElementById("root");

const root = createRoot(container)

root.render(
  <React.StrictMode>
		<ConfigProvider
			theme={{
				token: {
					borderRadius: 2
				}
			}}
		>
			<App />
		</ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
